import { CloudOff, UploadCloud } from "lucide-react";
import { useOnline, useQueue } from "@/lib/captureQueue";

export const QueueIndicator = () => {
  const items = useQueue();
  const online = useOnline();
  if (!items.length && online) return null;
  const errors = items.filter((i) => i.status === "error").length;
  return (
    <div data-testid="queue-indicator" className="mx-4 mb-2 px-3 py-2 rounded-xl text-xs flex items-center gap-2 bg-amber-500/10 border border-amber-500/30 text-amber-700 dark:text-amber-300">
      {online ? <UploadCloud className="w-4 h-4 shrink-0" /> : <CloudOff className="w-4 h-4 shrink-0" />}
      <span data-testid="queue-indicator-text">
        {items.length ? `${items.length} pendiente${items.length > 1 ? "s" : ""} de subir` : "Sin conexión"}
        {errors ? ` · ${errors} con error` : ""}
        {!online && items.length ? " · se subirán solas al volver la señal (con la app abierta)" : ""}
      </span>
    </div>
  );
};
